export default {
  currentCourse: {},
  currentStudentList: [],
  currentSelectedStudent: {},
  classList: [],
  currentStudentAttendance: {
    time: '',
    date: '',
  },
  currentAttendanceFilter: {},
  studentListScheduleBase: [],
  currentSchulde: {},
  studentReceivedFees: [],
  studentReceivableFees: [],
  activeStudent: JSON.parse(localStorage.getItem('currentActiveStudent')),
  listenStorage: false,
  currentStepForRegistration: '',
  toggleFormStepModal: false,
}
